<template>
  <div class="aboutmap">
    <div class="mapimg" data-aos="zoom-in">
      <img class="left-img" src="@/assets/aboutpic/map.png" alt="Map Image" />
      <div class="right-img">
        <img src="@/assets/aboutpic/mapL.png" alt="MapL Image" />
        <img src="@/assets/aboutpic/mapR.png" alt="MapR Image" />
        <div class="abouttext">
          <div class="abouttext-section">
            <span>
              {{ $t("aboutmap1") }}
            </span>
          </div>
          <div class="abouttext-section">
            <span>
              {{ $t("aboutmap2") }}
            </span>
          </div>
        </div>
        <div class="map_logo">
          <div class="logo-header">
            <img src="@/assets/contactpic/map_logo.png" />
            <h1>{{ $t("contactMapText") }}</h1>
          </div>
          <h2>400-0868-365</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactMap",
};
</script>

<style scoped>
.aboutmap {
  background-color: #f6f6f6;
  margin-top: 1vw;
  display: grid;
  grid-template-columns: 1fr;
  padding-left: 10vw;
  padding-right: 10vw;
}

.mapimg {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 80vw;
  justify-self: center;
}

.left-img {
  width: 100%;
  height: auto;
  align-self: center;
}

.right-img {
  display: grid;
  grid-template-rows: 1fr 1fr 1.5fr 1fr;
  justify-items: center;
  padding-top: 5vw;
}

.right-img img {
  width: 50%;
  height: auto;
}

.abouttext {
  padding: 2vh 7vw;
  display: flex;
  flex-direction: column;
}

.abouttext-section {
  line-height: 1.5em;
  text-indent: 2em;
}

.map_logo {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-header {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.map_logo img {
  width: 2vw;
  height: 2vw;
  margin-right: 20px;
}

.map_logo h1 {
  margin: 0;
}

.map_logo h2 {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/contact/contactItem/ContactMap.vue